import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_PIPELINE_STATUS_ACTION_TYPE } from '../actions/pipelineStatus.actions';

const initialState = null;

const pipelineStatusReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_PIPELINE_STATUS_ACTION_TYPE.SET_PIPELINE_STATUS:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default pipelineStatusReducer;
